import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@material-ui/core'

/**
 * Centered "not run yet" state for an application report tab: title, what the
 * report gives you, and the action that runs it. Matches the Credit Memo and
 * Taxes empty states so every tab starts the same way.
 */
const ReportEmptyState = ({ title, description, action, note }) => (
  <Box
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '400px',
      padding: '32px 16px',
      textAlign: 'center'
    }}
  >
    <Typography variant="h4" style={{ marginBottom: '16px', fontWeight: 600 }}>
      {title}
    </Typography>
    <Typography
      variant="body1"
      style={{ marginBottom: '32px', color: '#666', maxWidth: '500px', lineHeight: 1.6 }}
    >
      {description}
    </Typography>
    {action}
    {note && (
      <Typography variant="body2" style={{ marginTop: '16px', color: '#666', maxWidth: '500px' }}>
        {note}
      </Typography>
    )}
  </Box>
)

ReportEmptyState.propTypes = {
  title: PropTypes.node.isRequired,
  description: PropTypes.node.isRequired,
  action: PropTypes.node,
  note: PropTypes.node
}

export default ReportEmptyState
